'use client';

import { usePathname } from 'next/navigation';
import Footer from './Footer';

const ConditionalFooter = () => {
    const pathname = usePathname();

    const hideFooter =
        /^\/doctor\/[^\/]+\/[^\/]+\/[^\/]+\/turn\/checkout$/.test(pathname);

    if (hideFooter) return null;

    return <Footer />;
};

export default ConditionalFooter;
